import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Card, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import SimpleBarReact from 'simplebar-react';
import Avatar, { AvatarGroup } from 'components/common/Avatar';
import { useEffect } from 'react';
//import { quickLinks } from 'data/quickLinks';
import Flex from 'components/common/Flex';
import { contextApp } from 'context';
import { companyService } from 'services';
import useErrors from 'hooks/useErrors';
import { useMutation } from '@tanstack/react-query';
import Charging from 'components/common/Charging';
import { checkDomain } from 'helpers/utils';

const Companies = () => {
 const { auth } = contextApp();

 const [show, setShow] = useState(null);
 const [isLoading, setIsLoading] = useState(false);
 const { changeCompany } = companyService.useApiCompany();

 const { setError } = useErrors();
 const { mutate } = useMutation(changeCompany);

 useEffect(() => {
  window.addEventListener('scroll', () => {
   window.innerWidth < 1200 && setShow(false);
  });
 }, []);

 const onSubmitData = async ({ id, website, subdomain }) => {
  setIsLoading(true);
  mutate(id, {
   onError: err => setError(err),
   onSuccess: async newData => {
    const { hostname, port } = window.location;
    const url = await checkDomain(hostname);
    localStorage.removeItem('sesion');
    return window.location.replace(
     (port ? `http://${[subdomain, url.domain].join('.')}:${port}` : website) + `/change/${newData?.token}`
    );
   }
  });
 };

 return (
  <Dropdown navbar={true} as="li" show={show} onToggle={() => setShow(!show)}>
   {isLoading && <Charging />}
   <Dropdown.Toggle bsPrefix="toggle" as="div" className="pe-0 ps-2 nav-link cursor-pointer">
    <OverlayTrigger
     key="left"
     placement="left"
     overlay={
      <Tooltip style={{ position: 'fixed' }} id="companyName">
       {auth?.company?.name}
      </Tooltip>
     }
    >
     <div className="theme-control-toggle-label pb-1">
      <AvatarGroup dense>
       {auth?.companies
        .filter((e, i) => e.company._id !== auth?.company?._id && i < 2)
        .map((e, i) => (
         <Avatar
          key={i}
          className="flex-shrink-0"
          src={e.company.logo}
          name={e.company.name}
          mediaClass={`fs-0  bg-${5 - i}00`}
         />
        ))}
       <Avatar
        className="flex-shrink-0"
        src={auth?.company?.logo}
        name={auth?.company?.name}
        mediaClass="fs-0 bg-300 text-primary"
       />
      </AvatarGroup>
     </div>
    </OverlayTrigger>
   </Dropdown.Toggle>

   <Dropdown.Menu className="dropdown-menu-card dropdown-menu-end dropdown-caret dropdown-caret-bg" show={show}>
    <Card className="dropdown-menu-end shadow-none">
     <SimpleBarReact className="nav-quick-links">
      <Card.Body>
       {[{ company: auth.company }, ...auth.companies.filter(e => e.company._id !== auth.company._id)].map((item, index) => (
        <Company key={index} {...item.company} index={index} onSubmitData={onSubmitData} />
       ))}
      </Card.Body>
     </SimpleBarReact>
    </Card>
   </Dropdown.Menu>
  </Dropdown>
 );
};

const Company = ({ _id, logo, name, website, subdomain, nit, index, onSubmitData }) => (
 <Flex
  alignItems="center"
  alignContent="center"
  className={classNames('d-block hover-bg-200 p-2 rounded-3 text-decoration-none cursor-pointer mb-1', {
   'bg-soft-success': !index
  })}
  onClick={() => onSubmitData({ id: _id, website, subdomain })}
 >
  <Avatar size="2xl" src={logo} name={name} mediaClass="fs-2 bg-soft-primary text-primary" />
  <div className="flex-1 ms-2">
   <h6 className="fs--2 mb-0"> {name} </h6>
   <p className="fs--2 mb-0">nit: {nit}</p>
   {/* hr && <div className="border-dashed border-bottom my-3" /> */}
  </div>
 </Flex>
);

Company.propTypes = {
 _id: PropTypes.string,
 logo: PropTypes.string,
 name: PropTypes.string,
 website: PropTypes.string,
 subdomain: PropTypes.string,
 nit: PropTypes.string,
 index: PropTypes.number,
 onSubmitData: PropTypes.func
};

Companies.propTypes = { auth: PropTypes.object };

export default Companies;
